import styles from 'style-guide/TypographyGuide.module.css';

interface HeadlineProps {
  title: string;
  textColor?: string;
}

export const Headline = ({ title, textColor }: HeadlineProps) => {
  return (
    <h1 className={`${styles.headline_one}`} style={{ color: textColor }}>
      {title}
    </h1>
  );
};
